export default function Home() {
  return (
    <div className="flex flex-col">
      <HeroSection />
      <StatsBar />
      <AdvantagesSection />
      <ProductsPreview />
      <TestimonialsSection />
      <CTASection />
    </div>
  );
}

function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden" aria-labelledby="hero-heading">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20modern%20lifestyle%20scene%20with%20soft%20natural%20lighting%2C%20elegant%20interior%20with%20wooden%20elements%20and%20warm%20amber%20accents%2C%20clean%20sophisticated%20atmosphere%2C%20artistic%20abstract%20background%20with%20gentle%20gradients%20in%20terracotta%20and%20cream%20tones%2C%20no%20people%2C%20luxurious%20yet%20minimal%20composition&width=1800&height=900&seq=jinman-hero-01&orientation=landscape"
        alt="jinman 品牌形象"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      <div className="relative z-10 w-full text-center px-4 md:px-6 flex flex-col items-center">
        <h1 id="hero-heading" className="font-heading text-3xl md:text-5xl text-white mb-4 tracking-wider">
          信赖之选，品质生活
        </h1>
        <p className="text-sm md:text-lg text-white/85 max-w-2xl mx-auto leading-relaxed mb-8">
          jinman 汇聚创新科技与人文关怀，为您打造卓越的产品体验与全方位的智能生活解决方案
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <a
            href="/categories"
            className="bg-primary-500 hover:bg-primary-600 text-background-50 font-medium px-8 py-3 rounded-md text-sm whitespace-nowrap transition-colors cursor-pointer no-underline"
          >
            探索产品
          </a>
          <a
            href="/about"
            className="border border-white/60 hover:border-white text-white hover:bg-white/10 font-medium px-8 py-3 rounded-md text-sm whitespace-nowrap transition-colors cursor-pointer no-underline"
          >
            了解我们
          </a>
        </div>
      </div>
    </section>
  );
}

function StatsBar() {
  const stats = [
    { value: '500万+', label: '全球用户' },
    { value: '30+', label: '覆盖国家' },
    { value: '99.7%', label: '客户满意度' },
    { value: '1200+', label: '企业客户' },
  ];

  return (
    <section className="bg-background-50 py-10 md:py-14" aria-label="品牌数据">
      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 max-w-4xl mx-auto">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="font-heading text-2xl md:text-4xl text-primary-600 mb-1">{stat.value}</p>
              <p className="text-xs md:text-sm text-foreground-600">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function AdvantagesSection() {
  const advantages = [
    { icon: 'ri-shield-check-line', title: '品质保证', desc: '每一款 jinman 产品都经过严格质检，符合国际标准，让您用得安心。' },
    { icon: 'ri-rocket-2-line', title: '创新驱动', desc: 'jinman 持续投入研发，以领先技术打造卓越产品，引领行业发展方向。' },
    { icon: 'ri-customer-service-2-line', title: '贴心服务', desc: '7×24 小时专业客服团队，随时为您解决使用中遇到的任何问题。' },
    { icon: 'ri-global-line', title: '全球视野', desc: 'jinman 产品远销全球 30+ 国家和地区，获得数百万用户的信赖与好评。' },
  ];

  return (
    <section className="bg-background-100 py-14 md:py-20" aria-labelledby="advantages-heading">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 id="advantages-heading" className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            为什么选择 jinman
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            四大核心优势，铸就 jinman 品牌的卓越品质与用户信赖
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
          {advantages.map((adv) => (
            <div key={adv.title} className="bg-background-50 rounded-lg p-6 md:p-7 text-center group hover:bg-primary-50/50 transition-colors">
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className={`${adv.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-2">{adv.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{adv.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function ProductsPreview() {
  const categories = [
    {
      icon: 'ri-smartphone-line', name: '智能硬件', desc: '全屋智能、穿戴设备等前沿科技产品', href: '/categories?tab=smart-hardware',
      image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20lifestyle%20smart%20home%20device%20photography%2C%20soft%20natural%20lighting%2C%20clean%20cream%20and%20terracotta%20background%2C%20elegant%20modern%20aesthetic%2C%20no%20text%20or%20logos%2C%20professional%20editorial%20style%2C%20harmonious%20warm%20tones&width=600&height=400&seq=home-cat-01&orientation=landscape'
    },
    {
      icon: 'ri-cloud-line', name: '数字服务', desc: '云端服务与数据管理平台', href: '/categories?tab=digital-services',
      image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20cloud%20computing%20digital%20service%20photography%2C%20soft%20natural%20lighting%2C%20clean%20cream%20and%20terracotta%20background%2C%20elegant%20modern%20aesthetic%2C%20no%20text%20or%20logos%2C%20professional%20editorial%20style&width=600&height=400&seq=home-cat-02&orientation=landscape'
    },
    {
      icon: 'ri-home-heart-line', name: '生活美学', desc: '品质生活与精致设计系列', href: '/categories?tab=lifestyle',
      image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20lifestyle%20aesthetic%20product%20photography%2C%20soft%20natural%20lighting%2C%20clean%20cream%20and%20terracotta%20background%2C%20elegant%20modern%20home%20decor%20style%2C%20no%20text%20or%20logos%2C%20professional%20editorial&width=600&height=400&seq=home-cat-03&orientation=landscape'
    },
    {
      icon: 'ri-building-2-line', name: '企业方案', desc: '定制化企业数字化转型方案', href: '/categories?tab=enterprise',
      image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20enterprise%20business%20solution%20photography%2C%20soft%20natural%20lighting%2C%20clean%20cream%20and%20terracotta%20background%2C%20elegant%20modern%20office%20style%2C%20no%20text%20or%20logos%2C%20professional%20editorial&width=600&height=400&seq=home-cat-04&orientation=landscape'
    },
  ];

  return (
    <section className="bg-background-50 py-14 md:py-20" aria-labelledby="products-heading">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 id="products-heading" className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            产品与服务
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            四大业务板块，全方位满足您的生活与工作需求
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.href}
              className="bg-background-100 rounded-lg overflow-hidden group cursor-pointer no-underline block hover:bg-background-200/70 transition-colors"
              data-product-shop
            >
              <div className="h-44 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="w-10 h-10 mb-3 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className={`${cat.icon} text-lg`}></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-900 mb-1">{cat.name}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{cat.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

function TestimonialsSection() {
  const testimonials = [
    { name: '张伟', role: '科技创业者', content: 'jinman 的智能家居产品彻底改变了我对智能生活的认知。从安装到使用，每一个环节都体现了品牌的用心和专业。', initials: 'ZW' },
    { name: '李娜', role: '家庭用户', content: '作为一个不太懂科技的家庭主妇，jinman 的产品上手非常简单。客服团队也很耐心，遇到问题总能第一时间解决。', initials: 'LN' },
    { name: '王建国', role: '企业CTO', content: '我们公司采购了 jinman 的企业解决方案，从部署到培训都非常专业。数据安全方面做得尤其出色。', initials: 'WJ' },
  ];

  return (
    <section className="bg-background-100 py-14 md:py-20" aria-labelledby="testimonials-heading">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 id="testimonials-heading" className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            用户口碑
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            听听 jinman 的用户怎么说，真实评价见证品牌力量
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {testimonials.map((t) => (
            <div key={t.name} className="bg-background-50 rounded-lg p-6 md:p-7">
              <div className="flex items-center gap-1 mb-4 text-primary-500">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-5">&ldquo;{t.content}&rdquo;</p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                  <span className="text-sm font-semibold text-accent-600">{t.initials}</span>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function CTASection() {
  return (
    <section className="relative w-full py-16 md:py-24 flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20background%20with%20amber%20and%20terracotta%20tones%2C%20soft%20flowing%20organic%20shapes%2C%20elegant%20minimalist%20composition%2C%20no%20text%2C%20luxurious%20smooth%20textures%2C%20warm%20inviting%20atmosphere&width=1800&height=600&seq=jinman-cta-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/55"></div>
      <div className="relative z-10 w-full text-center px-4 md:px-6 flex flex-col items-center">
        <h2 className="font-heading text-2xl md:text-3xl text-white mb-4">
          准备好开启 jinman 之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-white/80 max-w-lg mx-auto mb-8">
          加入全球 500 万+ 用户的大家庭，体验 jinman 带来的全新价值与解决方案
        </p>
        <a
          href="/categories"
          className="bg-accent-500 hover:bg-accent-600 text-background-50 font-medium px-10 py-3.5 rounded-md text-sm whitespace-nowrap transition-colors cursor-pointer no-underline"
        >
          立即探索产品
        </a>
      </div>
    </section>
  );
}